// extracted by mini-css-extract-plugin
export default {"wrapperElement":"UserEditElement_wrapperElement__5YGPF","inputGroup":"UserEditElement_inputGroup__YFsPD"};